export default  {
  methods: {
    clearQueryParameters(obj) {
      for (let propName in obj) {
        if (obj.hasOwnProperty(propName)) {
          if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
            delete obj[propName];
          }
        }
      }
      return obj;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Recipes/Mixins/Filter.js